import { createStore, applyMiddleware } from "redux";
import { reducer } from "./TheReducer";
import { thunk } from "redux-thunk";

// We here created the middleware and the store which the reducer saves data in it.
let store = createStore(reducer, applyMiddleware(thunk));

export default store;
